module.exports = __webpack_public_path__ + "SourceSansPro-SemiBoldItalic.4721745ed6bad9131c31.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/SourceSansPro-SemiBoldItalic.woff2
// module id = ../../../../../src/assets/customfonts/SourceSansPro-SemiBoldItalic.woff2
// module chunks = styles